const getMapTypes = (type) => {
  const types = {
    point: 'Маркер на карте (Точка)',
    polygon: 'Область на карте (Полигон)',
    linestring: 'Линия на карте (Линейный)',
    orthophotomap: 'Снимок на карте (Ортофотоплан)',
    model: '3D модель',
    region: 'Данные по регионам',
    tms: 'TMS',
    'external-url': 'Geojson по внешней ссылке (WFS, URL)',
    custom: 'Программный',
  };
  if (type === 'event') types.history = 'Событие с историей';
  return types;
};

export const MAP_TYPES = {
  layer: getMapTypes('layer'),
  event: getMapTypes('event'),
  all: { ...getMapTypes('layer'), ...getMapTypes('event') },
};

export const OBJECT_TYPES = {
  layer: 'Слой',
  event: 'Событие',
};

const LAYER_MAP_TYPES_FOR_SELECT = Object.keys(MAP_TYPES.layer)
  .map(_ => ({ id: _, title: MAP_TYPES.layer[_] }));

const EVENT_MAP_TYPES_FOR_SELECT = Object.keys(MAP_TYPES.event)
  .map(_ => ({ id: _, title: MAP_TYPES.event[_] }));

export const MAP_TYPES_FOR_SELECT = {
  event: EVENT_MAP_TYPES_FOR_SELECT,
  layer: LAYER_MAP_TYPES_FOR_SELECT,
};

export const OBJECT_TYPES_FOR_SELECT = Object.keys(OBJECT_TYPES)
  .map(_ => ({ id: _, title: OBJECT_TYPES[_] }));

export default {
  MAP_TYPES,
  OBJECT_TYPES,
  MAP_TYPES_FOR_SELECT,
  OBJECT_TYPES_FOR_SELECT,
};
